// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper_2qTjp","isBlock":"Table_isBlock_2cuaO","tableScrollable":"Table_tableScrollable_1IE4Q","table":"Table_table_3mI8L","noData":"Table_noData_25r32"};